import client from './client';

export async function listUsers(params) {
  const { data } = await client.get('/users', { params });
  return data.data; // Laravel paginator: { data: [...], current_page, last_page, total, ... }
}

export async function getUser(id) {
  const { data } = await client.get(`/users/${id}`);
  return data.data;
}

export async function createUser(payload) {
  const { data } = await client.post('/users', payload);
  return data.data;
}

export async function updateUser(id, payload) {
  const { data } = await client.put(`/users/${id}`, payload);
  return data.data;
}

export async function deleteUser(id) {
  await client.delete(`/users/${id}`);
}

export async function toggleUserStatus(id) {
  const { data } = await client.patch(`/users/${id}/toggle-status`);
  return data.data;
}

export async function syncUserRoles(id, roles) {
  const { data } = await client.put(`/users/${id}/roles`, { roles });
  return data.data;
}

export async function syncUserPermissions(id, permissions) {
  const { data } = await client.put(`/users/${id}/permissions`, { permissions });
  return data.data;
}
